module.exports = __webpack_public_path__ + "static/media/grocery-product-4.244da2eb.png";